module.exports = __webpack_public_path__ + "img/d4.1a9f4d32.png";